import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import {grey} from "@material-ui/core/colors";

type Props = {
  className?: string;
  fillColor?: string;
  style?: React.CSSProperties;
};

const ApprovalIcon = ({
  className,
  fillColor,
  style,
}: Props): React.ReactElement => (
  <SvgIcon
    className={className}
    style={{height: 24, width: 24, ...style}}
    viewBox="0 0 24 24"
  >
    <path
      d="M22 5.18L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L20.59 3.78L22 5.18ZM19.79 10.22C19.92 10.79 20 11.39 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C13.58 4 15.04 4.46 16.28 5.25L17.72 3.81C16.1 2.67 14.13 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.81 21.78 9.67 21.4 8.61L19.79 10.22Z"
      fill={fillColor}
    />
  </SvgIcon>
);
ApprovalIcon.defaultProps = {
  className: "",
  fillColor: grey[500],
  style: {},
};

export default ApprovalIcon;
